


























export default {
  name: 'PhoneInfo',
  data(): { menu: boolean; phoneNumber: string } {
    return {
      menu: false,
      phoneNumber: 'XXX-XXX-XXXX',
    }
  },
  methods: {
    // add notification to user that action was completed
    copyPhoneNumber(): void {
      navigator.clipboard.writeText('216-379-9501')
    },
  },
}
